import React from "react";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { getFormattedDate } from "../../helpers/date.helper";
import { useDispatch, useSelector } from "react-redux";
import {
  setResetUnmatched,
  setUnmatchedChanged,
} from "../../store/openBetsList/openBetsList.slice";
import { getCurrencyFormatRoundedOff } from "../../helpers/getCurrencyFormat.helper";
import {
  setHrCountryCode,
  setHrEventId,
  setHrMarketId,
  setIsDetailedGroupName,
  setIsEventDetailed,
  setIsNavigationID,
  setIsNavigationName,
} from "../../store/navigationHeaderMenu/navigationHeaderMenu.slice";
import { requestHomeAllCompetition } from "../../store/homeMarketEvents/homeMarketEvents.thunks";

const DesktopOpenBetsItem = ({
  timeSettings,
  bet,
  isEvent,
  isUnmatched = false,
  cancel,
  redirect = false,
  consolidate,
  stake,
  isAverage,
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const setInfoDispatch = useSelector((state) => state.openBetsList.detailed);
  const [isRemovingBet, setIsRemovingBet] = useState(false);

  // console.log(bet);

  // const isInfo = useSelector((state) => state)

  const [unmatchedOdd, setUnmatchedOdd] = useState(bet?.price || 0);
  const [unmatchedStake, setUnmatchedStake] = useState(bet?.stake || 0);
  const resetUnmatched = useSelector((state) => state.openBetsList.reset);

  // const ripple = (event) => {
  //   const elem = event.currentTarget;

  //   var rect = event.target.getBoundingClientRect();
  //   let x = event.clientX - elem.offsetLeft;
  //   let y = rect.height - rect.bottom + event.clientY;
  //   let rippleElement = document.createElement("span");
  //   rippleElement.style.left = x + "px";
  //   rippleElement.style.top = y + "px";
  //   elem.appendChild(rippleElement);
  //   setTimeout(function () {
  //     rippleElement.remove();
  //   }, 500);
  // };

  useEffect(() => {
    if (resetUnmatched && isUnmatched) {
      setUnmatchedOdd(bet?.odds);
      setUnmatchedStake(bet?.stake);
      dispatch(setResetUnmatched(false));
    }
  }, [resetUnmatched]);

  useEffect(() => {
    if (
      (isUnmatched && unmatchedStake !== bet?.stake) ||
      unmatchedOdd !== bet?.odds
    ) {
      dispatch(setUnmatchedChanged(true));
    }
  }, [unmatchedStake, unmatchedOdd]);

  const changeOdd = (mod, isChanging = 1) => {
    let step, dec;
    const odd = Number(unmatchedOdd);
    switch (true) {
      case odd < 2: {
        step = 0.01;
        dec = 2;
        break;
      }
      case odd < 3: {
        step = 0.02;
        dec = 2;
        break;
      }
      case odd < 4: {
        step = 0.05;
        dec = 2;
        break;
      }
      case odd < 6: {
        step = 0.1;
        dec = 2;
        break;
      }
      case odd < 10: {
        step = 0.2;
        dec = 2;
        break;
      }
      case odd < 20: {
        step = 0.5;
        dec = 1;
        break;
      }
      case odd < 30: {
        step = 1;
        dec = 0;
        break;
      }
      case odd < 50: {
        step = 2;
        dec = 0;
        break;
      }
      case odd < 100: {
        step = 5;
        dec = 0;
        break;
      }
      default: {
        step = 10;
        dec = 0;
      }
    }
    let newVal = +(odd + step * mod * isChanging).toFixed(2);
    if (newVal < 1.01) newVal = 1.01;
    else if (newVal > 1000) newVal = 1000;
    else if (!Number.isInteger(newVal / step))
      newVal = newVal - (newVal % step) + step;
    newVal = Number(newVal.toFixed(dec));
    setUnmatchedOdd(newVal);
  };

  // useEffect(() => {
  //   console.log(consolidate, '2222')
  // }, [consolidate])

  const getPriseFor_SB = (marketId, price) => {
    return marketId && marketId.slice(marketId.length - 3) === "_SB"
      ? ((price - 1) * 100).toFixed(2).replace(".00", "")
      : price;
  };

  const getTitle = () => {
    const isBack = bet.side == "Back";
    const isFancy =
      bet.marketType == "INNINGS_RUNS" && bet.marketBettingType == "LINE";
    const text = isFancy
      ? `${bet.line} runs - ${isBack ? "Yes" : "No"}`
      : bet.side;
    const profit = isFancy
      ? ((bet.size * bet.price) / 100).toFixed(2)
      : (bet.size * bet.price - bet.size).toFixed(2);
    //TODO: maybe change averagePrice to price ?
    const averagePrice = getPriseFor_SB(bet.marketId, bet.averagePrice);
    return profit;
  };

  const getName = () => {
    if (bet.eventName.indexOf("${HH:mm}") != -1) {
      const formattedOpenDate = getFormattedDate(
        bet.marketTime,
        timeSettings.timeZoneName
      );
      return bet.eventName.replace(/\${HH:mm}/, formattedOpenDate.time);
    } else {
      return bet.eventName;
    }
  };

  const colspan3or6 = (marketType) =>
    marketType === 1 ? "col-span-3" : "col-span-6";

  return !isAverage ? (
    !consolidate ? (
      <div
        className={`grid grid-cols-6 font-semibold px-2 py-1 cursor-pointer rounded w-full text-xs capitalize ${
          bet?.event_type === "oddeven"
            ? bet?.is_back === 1
              ? "bg-bg_BackBtnBg"
              : "bg-bg_BackBtnBg"
            : bet?.is_back === 1
            ? "bg-bg_BackBtnBg"
            : "bg-bg_LayBtnBg"
        }`}
        onClick={() => {
          if (redirect && !location.pathname.includes("event-page")) {
            dispatch(setIsDetailedGroupName(bet?.series_name));
            dispatch(setIsEventDetailed(false));
            const data = {
              sport_id: bet?.sport_id,
            };

            dispatch(requestHomeAllCompetition(data));

            if (bet?.sport_id === "7" || bet?.sport_id === "4339") {
              dispatch(setIsNavigationID(bet?.sport_id));
              dispatch(
                setIsNavigationName(
                  bet?.sport_id === "7" ? "Horse Racing" : "Greyhound Racing"
                )
              );
              dispatch(setHrEventId(bet.match_id));
              dispatch(setHrMarketId(bet?.market_id));

              navigate(
                bet?.sport_id === "7" ? "/horse-racing" : "/greyhound-racing"
              );
              return;
            }
            navigate(`/event-page/${bet?.sport_id}/${bet?.match_id}`);
          }
        }}
      >
        <span className="col-span-2">
          {bet.is_fancy === 1 ? bet?.odds : bet?.market_name}
        </span>
        <span className="col-span-1 text-center">{bet?.odds}</span>
        <span className="col-span-1 text-center">
          {getCurrencyFormatRoundedOff(
            bet?.is_back === 1 ? bet?.stack : bet?.liability
          )}
        </span>
        <span className="col-span-2 text-center">
          {getCurrencyFormatRoundedOff(bet?.profit)}
        </span>
      </div>
    ) : (
      <div
        className={`p-1 rounded font-lato font-semibold  ${
          bet?.event_type === "oddeven"
            ? bet?.is_back === 1
              ? "bg-bg_BackBtnBg"
              : "bg-bg_BackBtnBg"
            : bet?.is_back === 1
            ? "bg-bg_BackBtnBg"
            : "bg-bg_LayBtnBg"
        }`}
      >
        <div className="grid grid-cols-12 gap-1 w-full text-xs font-lato capitalize cursor-pointer">
          {bet?.is_fancy === 1 && (
            <span className="col-span-3 text-center">{bet?.selectionName}</span>
          )}
          <span className="col-span-3 text-center">{bet?.odds}</span>
          <span className="col-span-3 text-center">
            {getCurrencyFormatRoundedOff(
              bet?.is_back === 1 ? bet?.stack : bet?.liability
            )}
          </span>
          <span className={`${colspan3or6(bet?.is_fancy)} text-center`}>
            {getCurrencyFormatRoundedOff(bet?.profit)}
          </span>
        </div>
      </div>
    )
  ) : (
    <div className="border p-1 rounded space-y-2">
      {stake[0]?.is_fancy !== 1 ? (
        <div className="w-full space-y-0.5">
          <div className="space-y-0.5">
            <span className=" text-text_Ternary  border font-semibold text-xs px-2 py-1 rounded bg-bg_Ternary8">
              {stake[0].name}
            </span>
            <div className="bg-bg_Ternary8 border rounded py-1 grid grid-cols-12 gap-1 w-full text-xs font-lato capitalize cursor-pointer">
              {stake[0]?.marketType === "SESSION" && (
                <span className="col-span-3 text-center text-text_Ternary  text-xs ">
                  Runs
                </span>
              )}
              <span className="col-span-3 text-center text-text_Ternary  text-xs ">
                Odds
              </span>
              <span className="col-span-3 text-center text-text_Ternary  text-xs ">
                Stake
              </span>
              <span
                className={`${colspan3or6(
                  stake[0]?.is_fancy
                )} text-center text-text_Ternary  text-xs `}
              >
                P/L
              </span>
            </div>
          </div>

          {stake[0].odds ? (
            <div className=" px-1 rounded py-1 font-lato cursor-pointer font-semibold  bg-bg_BackBtnBg">
              <div className="grid grid-cols-12 gap-1 w-full text-xs font-lato capitalize cursor-pointer">
                {stake[0]?.marketType === "SESSION" && (
                  <span className="col-span-3 text-center">
                    {stake[0]?.selectionName}
                  </span>
                )}
                <span className="col-span-3 text-center">{stake[0]?.odds}</span>
                <span className="col-span-3 text-center">
                  {getCurrencyFormatRoundedOff(stake[0]?.stake)}
                </span>
                <span
                  className={`${colspan3or6(stake[0]?.marketType)} text-center`}
                >
                  {getCurrencyFormatRoundedOff(stake[0]?.profit)}
                </span>
              </div>
            </div>
          ) : null}
          {stake[1].odds ? (
            <div className=" px-1 rounded py-1 font-lato cursor-pointer font-semibold  bg-bg_LayBtnBg">
              <div className="grid grid-cols-12 gap-1 w-full text-xs font-lato capitalize cursor-pointer">
                {stake[1]?.is_fancy === 1 && (
                  <span className="col-span-3 text-center">
                    {stake[1]?.selectionName}
                  </span>
                )}
                <span className="col-span-3 text-center">{stake[1]?.odds}</span>
                <span className="col-span-3 text-center">
                  {getCurrencyFormatRoundedOff(stake[1]?.stake)}
                </span>
                <span
                  className={`${colspan3or6(stake[1]?.is_fancy)} text-center`}
                >
                  {getCurrencyFormatRoundedOff(stake[1]?.profit)}
                </span>
              </div>
            </div>
          ) : null}
        </div>
      ) : (
        stake.map((item) => {
          return (
            <div className="w-full space-y-0.5">
              <div className="space-y-0.5">
                <span className=" text-text_Ternary  border font-semibold text-xs px-2 py-1 rounded bg-bg_Ternary8">
                  {item?.market_name}
                </span>
                <div className="bg-bg_Ternary8 border rounded py-1 grid grid-cols-12 gap-1 w-full text-xs font-lato capitalize cursor-pointer">
                  <span className="col-span-3 text-center text-text_Ternary  text-xs ">
                    Runs
                  </span>
                  <span className="col-span-3 text-center text-text_Ternary  text-xs ">
                    Odds
                  </span>
                  <span className="col-span-3 text-center text-text_Ternary  text-xs ">
                    Stake
                  </span>
                  <span className="col-span-3 text-center text-text_Ternary  text-xs ">
                    P/L
                  </span>
                </div>
              </div>
              <div
                className={` px-1 rounded py-1 font-lato cursor-pointer font-semibold  ${
                  item?.type == "Back" ? "bg-bg_BackBtnBg" : "bg-bg_LayBtnBg"
                }`}
              >
                <div className="grid grid-cols-12 gap-1 w-full text-xs font-lato capitalize cursor-pointer">
                  <span className="col-span-3 text-center">
                    {item?.selectionName}
                  </span>
                  <span className="col-span-3 text-center">{item?.odds}</span>
                  <span className="col-span-3 text-center">
                    {getCurrencyFormatRoundedOff(
                      item?.is_back === 1 ? item?.stack : item?.liability
                    )}
                  </span>
                  <span className="col-span-3 text-center">
                    {getCurrencyFormatRoundedOff(item?.profit)}
                  </span>
                </div>
              </div>
            </div>
          );
        })
      )}
    </div>
  );
};

export default DesktopOpenBetsItem;
